import script from "./ParallelChannelTool.vue?vue&type=script&lang=js"
export * from "./ParallelChannelTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__